import FilesService from '../services/files.service';

export const files = {
  namespaced: true,
  actions: {
    uploadFileToS3({ commit }, file) {
      return FilesService.uploadFileToS3(file);
    }
  },
  mutations: {
  }
};

